import { connect } from 'react-redux'

import JoinManagerForm from 'app/bond_cover/managers/review/bc_join_form_container'

export default connect()(JoinManagerForm)
